// One normalisation for both tables and both apps. The invariant the address line and the UI
// lookup both depend on -- that they resolve the same input identically -- should be structural
// rather than two copies of the same expression that have to be kept in agreement.
export function normalizeCountryCode(countryCode) {
    return countryCode ? String(countryCode).trim().toUpperCase() : "";
}
